import { z } from 'zod'
import { LEAD_SOURCES } from '../api/leadsApi'

export const leadSchema = z.object({
  // Basic Info
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().optional().or(z.literal('')),
  email: z.string().email('Invalid email').optional().or(z.literal('')),
  contactNumber: z.string()
    .min(1, 'Contact number is required')
    .regex(/^[6-9]\d{9}$/, 'Contact number must be a valid 10-digit mobile number starting with 6-9'),
  designation: z.string().optional(),
  contactSource: z.string().optional(),
  source: z.enum(LEAD_SOURCES).optional().refine(val => !!val, 'Source is required'),
  owner: z.string().optional(),
  // Company Info
  gst: z.string().optional().refine(val => !val || /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/i.test(val), 'Invalid GST format'),
  pincode: z.string().optional().refine(val => !val || /^[1-9][0-9]{5}$/.test(val), 'Invalid Pincode (6 digits)'),
  address: z.string().optional(),
  companyName: z.string().min(1, 'Company name is required'),
  companyWebsite: z.string().optional(),
  industry: z.string().optional(),
  customerTypeId: z.number().optional(),
  description: z.string().optional(),
  bestTimeToContact: z.string().optional(),
  requirements: z.string().optional(),
  fileType: z.string().optional(),
  expectedCloseDate: z.string().optional(),
  expectedAmount: z.number().optional().nullable(),
  // Tenant Assignment
  orgId: z.string().min(1, 'Organisation is required'),
  lobId: z.string().min(1, 'Line of Business is required'),
  warehouseId: z.string().optional(),
})

export type LeadFormData = z.infer<typeof leadSchema>

